module.exports = __webpack_public_path__ + "static/media/BGP-TIJ.457d4056.jpg";